import { 
    hideWithClass, role, observable, id, getId, reactTo, log, prop, setDebug,
    type Role, type Property
} from "../dist/index.js";

const state = observable({
    themeColor: localStorage.getItem("THEME_COLOR") || "azure",
    darkMode: localStorage.getItem("DARK_MODE")?.length ? localStorage.getItem("DARK_MODE") != "0" :
    window.matchMedia('(prefers-color-scheme: dark)').matches,
    themes: [
        { color: "red" },
        { color: "pink" },
        { color: "fuchsia" },
        { color: "purple" },
        { color: "violet" },
        { color: "indigo" },
        { color: "blue" },
        { color: "azure", name: ""},
        { color: "cyan" },
        { color: "jade" },
        { color: "green" },
        { color: "lime" },
        { color: "yellow" },
        { color: "amber" },
        { color: "pumpkin" },
        { color: "orange" },
        { color: "sand" },
        { color: "grey" },
        { color: "zinc" },
        { color: "slate" },
    ], 
    text : "",
    text2 : 2,
    radio : "French",
    format : "",
    test: undefined as string | undefined
});

hideWithClass("duh");

const global = (root : Role, ctx : typeof state) => {
    
    root.attribute("data-theme", () => ctx.darkMode ? "dark" : "light")
    
    root.role("theme")
        .attribute("href", () => {
            const theme = ctx.themes?.find((t : any) => t.color === ctx.themeColor);
 
            let themeSpec = "";

            if(theme) {
                themeSpec = theme.name ?? theme.color;
                if(themeSpec) {
                    themeSpec += ".";
                }
            }

            return `https://cdn.jsdelivr.net/npm/@picocss/pico@2/css/pico.${themeSpec}min.css`;

        });
}

const page = (root : Role, ctx : typeof state) => { 

    reactTo(() => ctx.themeColor).with((color) => 
        localStorage.setItem("THEME_COLOR", color ?? ""));

    reactTo(() => ctx.darkMode).with((darkMode) => 
        localStorage.setItem("DARK_MODE", darkMode ? "1" : "0"));

    root.role("light-switch")
        .model(prop(() => ctx, "darkMode"));

    prop(() => ctx, "test").compute(() => ctx.darkMode ? "one" : undefined);
    log(() => ctx.test);

    root.role("color-theme-picker")
        .model(prop(() => ctx, "themeColor"))
        .for(() => ctx.themes, (option, theme) => option
            .attribute("selected", () => theme.color == ctx.themeColor ? "" : null)
            .text(theme.color)
        );

    root.role("d", { optional: true })
        .model(prop(() => ctx, "themeColor"))
        .for(ctx.themes, (option, theme) => option
            .attribute("selected", () => theme.color == ctx.themeColor ? "" : null)
            .text(theme.color)
        );

    root.role("text-input")
        .model(prop(ctx, "text"))
        .attribute("id", id());

    root.role("input-label")
        .attribute("for", getId());

    let i = 0;
    reactTo(() => ctx.darkMode)
         .withReset((darkMode) => {
            if(!darkMode) {
                root.role("hide-section")
                    .show(true)
                    .html(() => darkMode?.toString() ?? "")
                    .on("click", () => { console.log("click" + ++i)})
            } else {
                root.role("hide-section")
                    .show(false)
            }
        });

    root.role("radio")
        .selectAll("[name='language']", rb => rb.model(prop(() => ctx, "radio")));
    
    log(() => ctx.radio)

    ctx.themes = ctx.themes.sort((a, b) => a.color.localeCompare(b.color));

    const formatCurrency = (amount : number | undefined, format: string | null) => {
        if(amount === undefined) {
            return "";
        }
        if(format === "k") {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits : 3
            }).format(amount/1000) + "k";
        } else if(format === "M") {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits : 3
            }).format(amount/1000000) + "M";
        } else {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(amount);
        }
    }

    const currencyInput = (
        amount : Property<number>
    ) => (root : Role) => {
        const usdRegex = /^\-?\$?(\d{1,3}(\,\d{3})*|(\d+))(.[0-9]*)?k?M?$/

        const state = observable({ 
            value: amount.value?.toString() ?? "",
            format: null,
            valid: true
        }) as { 
            value : string; 
            format : string | null; 
            valid : boolean;
        };

        reactTo(amount).with((value? : number) => state.value = formatCurrency(value, state.format));
        reactTo(() => state.format).with(format => state.value = formatCurrency(amount.value, format ?? null));

        root.on("keydown", ((e : KeyboardEvent) => {
                if (!e.ctrlKey && (!"$1234567890.-,".includes(e.key) && e.key.length === 1) 
                    || e.key === "Enter") {
                    e.preventDefault();
                }
            }) as (e : Event) => e is KeyboardEvent)
            .onAttribute("format", (format) => state.format = format)
            .model(prop(state, "value"))
            .on("focus", () => {
                if(state.valid) {
                    state.value = amount.value?.toString() ?? "";
                }
            })
            .on("blur", () => {
                if(state.value.match(usdRegex)) {
                    state.valid = true;
                    amount.value = Number(state.value.replace(/\,|\$*/g, ""));
                    state.value = formatCurrency(Number(state.value.replace(/\,|\$*/g, "")), state.format);
                } else {
                    state.valid = false;
                }
            })
            .attribute("aria-invalid", () => state.valid ? null : "true");
    }
    


    root.role("text2-input")
        .connect(currencyInput(prop(state, "text2")))
        .attribute("format", () => ctx.format || null);

    log(() => state.text2);
    
    root.role("format")
        .model(prop(ctx, "format"));

    log(() => state.text);

    reactTo(() => state.format).with(async (value) => console.log(value));
}

setDebug('verbose');

global(role("global"), state);
page(role("page"), state);


(async () => {
    await new Promise<void>(r => setTimeout(() => r(), 1000))
    console.time();
for( let i = 0; i < 20; i++) {
    let j= Math.floor(Math.random()*20);
    let k= Math.floor(Math.random()*19);
    let sav = state.themes.splice(j, 1)
    state.themes.splice(k, 0, sav[0]);
    role("color-theme-picker").value(state.themeColor);
    await new Promise<void>(r => setTimeout(() => r(), 100))
}
console.timeEnd()
})()

if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(
        async (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
            const pointsResponse = await fetch(`https://api.weather.gov/points/${latitude},${longitude}`)
            const pointsJSON = await pointsResponse.json();
            console.log(pointsJSON, +"*" +pointsJSON.properties)
            const forecastResponse = await fetch(pointsJSON.properties.forecastHourly);
            const forecastJSON = await forecastResponse.json();
            console.log(forecastJSON);
           
        },
        (error) => {
            console.error(`Error code: ${error.code} - ${error.message}`);
        },
        {
            enableHighAccuracy: true, // Uses GPS if available
            timeout: 5000,            // Wait time in milliseconds
            maximumAge: 0             // Do not use cached location
        }
    );
} else {
    console.log("Geolocation is not supported by this browser.");
}


//  const pop = state.themes.pop();
//  debounce(() => state.themes.unshift(pop), 1);
//  debounce(() => state.themes.shift(), 2);
//  debounce(() => state.themes.push(pop), 3);
//state.themes.shift();
//state.themes.pop();
// state.themes.push(pop);
// let s = state.themes.splice(6, 1);
// state.themes.push(s[0]);
// s = state.themes.pop();
// state.themes.push(s);

//   state.themes.splice(6, 0, s);
// const save = state.themes;
// // setTimeout(() => {
// //   const s = state.themes.splice(6, 1);
// //   state.themes.push(s[0]);
// // }, 5000);
// setTimeout(() => {
//   //const s = state.themes.splice(6, 1);
//   state.themes = undefined;
// }, 50000000);

// setTimeout(() => {
//   const s = state.themes.pop();
//   state.themes.splice(6, 0, s);
// }
//, 10000);
// setTimeout(() => {
//   state.themes = save;
// }
//  , 1000000000);


//state.themes = save;

state.text = "2020-01-01";

//console.log(Reflect.ownKeys(state.themes).map(k => state.themes[k]))